import { AlertCircle, InfoCircle } from "@untitledui/icons";

/**
 * The three non-data states every list and detail page shares. Kept as one
 * component so "could not load" and "nothing here" never get conflated: an
 * empty organization is not a failure, and a failure is not an empty list.
 */
interface StatusMessageProps {
	empty?: string;
	error?: Error | null;
	isEmpty?: boolean;
	isLoading?: boolean;
	loading?: string;
}

export const StatusMessage = ({
	empty = "Nothing here yet.",
	error,
	isEmpty,
	isLoading,
	loading = "Loading…",
}: StatusMessageProps) => {
	if (isLoading) {
		return (
			<p className="flex items-center gap-2 text-sm text-secondary">
				<span
					aria-hidden="true"
					className="size-4 animate-spin rounded-full border-2 border-fg-quaternary border-t-transparent"
				/>
				{loading}
			</p>
		);
	}
	if (error) {
		return (
			<p
				className="flex items-start gap-2 text-sm text-error-primary"
				role="alert"
			>
				<AlertCircle aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
				<span>Could not load. {error.message}</span>
			</p>
		);
	}
	if (isEmpty) {
		return (
			<p className="flex items-start gap-2 text-sm text-secondary">
				<InfoCircle aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
				<span>{empty}</span>
			</p>
		);
	}
	return null;
};
